  let scrollpostwo = window.scrollY
  const header = document.querySelector(".header")
  const header_height = header.offsetHeight

  window.addEventListener('scroll', function() { 
    scrollpostwo = window.scrollY;

    if (scrollpostwo >= header_height) { header.classList.add("header-full") }
    else { header.classList.remove("header-full") }

    console.log(scrollpostwo)
  })


//  $('.main_image').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   fade: true,
//   asNavFor: '.thumb_image'
// });
// $('.thumb_image').slick({
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   asNavFor: '.main_image',
//   dots: true,
//   centerMode: true,
//   focusOnSelect: true
// });